import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { useState } from 'react';
import { IsSuperAdmin } from './IsSuperAdmin';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useTranslation } from 'react-i18next';

interface PurgeButtonProps {
  service: any;
  refresh?: any;
  isMovement?: boolean;
}

export function PurgeButton({ service, refresh, isMovement }: PurgeButtonProps) {
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);

  const toggleOpenDialog = () => {
    setOpenDialog(!openDialog);
  };

  const confirmBulkDelete = () => {
    service?.bulkDelete().then(() => {
      if (refresh) refresh?.current();
    });
  };

  return (
    <>
      <ButtonGroup className="px-2">
        <IsSuperAdmin>
          <Button
            variant="outlined"
            size="small"
            onClick={toggleOpenDialog}
            color="error"
            title={t('actions.purge')}>
            <DeleteForeverIcon />
          </Button>
        </IsSuperAdmin>
      </ButtonGroup>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="md">
        <DialogTitle id="alert-dialog-title">{t(`global.delete-confirmation`)}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>{t(`global.delete-confirmation-extended`)}</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="w-full flex justify-between">
            <Button onClick={toggleOpenDialog}>{t('actions.cancel')}</Button>
            <div>
              <Button variant="contained" color="error" onClick={confirmBulkDelete} autoFocus>
                {t('actions.delete')}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
